'use strict';
import * as _ from 'lodash';
import { module } from '../app';

module
  .factory('FollowUpResolveDialogModel', [
    function () {

      function FollowUpResolveDialogModel(patientAccessToken, clip, followUp, checkIfStillOwningAndNotOffline) {
        let self = this;

        self.followUp = followUp;
        self.patientAccessToken = patientAccessToken;
        self.clip = clip;
        self.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;
        self.loading = false;

        self.init = async (modal, scope) => {
          self.modalInstance = modal;
          self._scope = scope;
        };

        self.resolveFollowUp = () => {
          self._scope.model.isCanceled = false;
          self.modalInstance.remove();
        }

        self.close = async () => {
          self._scope.model.isCanceled = true;
          self.modalInstance.remove();
        };
      }

      return FollowUpResolveDialogModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/followUpResolveDialogModel.js